import { useEffect, useState } from 'react';

type DeferredInstallPrompt = Window['__DeferredPrompt__'];

const readDeferredPrompt = (): DeferredInstallPrompt | null => {
  if (typeof window === 'undefined') return null;
  return window.__DeferredPrompt__ ?? null;
};

// beforeinstallprompt fires asynchronously and may arrive before InstallPrompt
// mounts (ClientOnly) or after a client-side navigation — reading
// window.__DeferredPrompt__ once per render leaves onInstall with a stale
// undefined. entry.client and Document also capture the event globally; this
// hook mirrors that value into React state so the install button can enable.
export const useDeferredInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<DeferredInstallPrompt | null>(readDeferredPrompt);

  useEffect(() => {
    const handler = (event: Event) => {
      event.preventDefault();
      const prompt = event as DeferredInstallPrompt;
      window.__DeferredPrompt__ = prompt;
      setDeferredPrompt(prompt);
    };

    const existingPrompt = readDeferredPrompt();
    if (existingPrompt) {
      setDeferredPrompt(existingPrompt);
    }

    window.addEventListener('beforeinstallprompt', handler);
    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  return deferredPrompt;
};
